import { render, staticRenderFns } from "./ReviewItemPanel.vue?vue&type=template&id=2de3017b&"
import script from "./ReviewItemPanel.vue?vue&type=script&lang=js&"
export * from "./ReviewItemPanel.vue?vue&type=script&lang=js&"
import style0 from "./ReviewItemPanel.vue?vue&type=style&index=0&id=2de3017b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports